import { useState, useTransition } from "react";

import { V2SearchField } from "@stacklet/ui";
import { useSearchParams } from "react-router";

interface Props {
  /** Placeholder text and aria-label for the search input */
  title: string;
  onSearch?: (search: string) => void;
  className?: string;
}

export function SearchBar({ title, onSearch, className }: Props) {
  const [searchParams, setSearchParams] = useSearchParams({});
  const [, startTransition] = useTransition();

  const search = searchParams.get("search");
  const [searchString, setSearchString] = useState(search || "");

  const handleSubmit = (value: string) => {
    searchParams.set("search", value);
    startTransition(() => setSearchParams(searchParams));
    onSearch?.(value);
  };

  const handleChange = (value: string) => {
    setSearchString(value);
    if (value === "") {
      handleSubmit("");
    }
  };

  return (
    <V2SearchField
      aria-label={title}
      className={className ?? "w-full"}
      data-testid="search-bar"
      inputProps={{ placeholder: title }}
      onChange={handleChange}
      onSubmit={handleSubmit}
      value={searchString}
      hasSubmitButton
    />
  );
}
